import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {Location} from '@angular/common';

@Component({
  selector: 'app-deep-link',
  providers: [],
  template: ''
})
export class DeepLinkComponent implements OnInit {
  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private _location: Location
  ) { }

  ngOnInit() {
    // subscribe to router event

    let os = {
      android: navigator.userAgent.match(/Android/i),
      ios: navigator.userAgent.match(/iPhone|iPad|iPod/i)
    };
    if (os.android || os.ios) {
      setTimeout(() => {
        if(os.ios)
        window.location.href = 'https://itunes.apple.com/us/app/go-hotel-life/id1318522300?ls=1&mt=8';
        if(os.android)
        window.location.href = 'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=sdei.trumpbeach.resort&hl=en';
      }, 300);
    }else{
      this._location.back();
    }
  }








}



// WEBPACK FOOTER //
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/deep-link/deep-link.component.ts